/**
 * @fileoverview PATCH handler for the "/app_groups/:app_group_id/placements/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appGroupsAppGroupIdPlacementsIdCacheKeys } from "./constants";
import type {
  PatchAppGroupsAppGroupIdPlacementsIdProps,
  PatchAppGroupsAppGroupIdPlacementsIdResult,
} from "./types";

export const patchAppGroupsAppGroupIdPlacementsId = reactQueryMutationAdapter(
  appGroupsAppGroupIdPlacementsIdCacheKeys,
  ({
    id,
    placementId,
    name,
    description,
    appGroupId,
    targeting,
  }: PatchAppGroupsAppGroupIdPlacementsIdProps): Promise<PatchAppGroupsAppGroupIdPlacementsIdResult> => {
    const targetingBody = targeting?.cssSelector && {
      css_selector: targeting.cssSelector,
      insertion_position: targeting.insertionPosition,
      ...(targeting.url && { url: targeting.url }),
      ...(targeting.urlMatchType && { url_match_type: targeting.urlMatchType }),
    };

    return fetch(
      `/app_groups/${appGroupId}/placements/${id}`,
      "PATCH",
      {
        placement_id: placementId,
        name,
        description,
        ...(targetingBody && { targeting: targetingBody }),
      },
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
